import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LabFinderModalComponent } from '@components/consultation-request/lab-finder-modal/lab-finder-modal.component';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Component({
  selector: 'app-follow-up-std-test',
  templateUrl: './follow-up-std-test.component.html',
  styleUrl: './follow-up-std-test.component.scss',
  imports: [UpsellCardComponent, NgIf, LabFinderModalComponent],
})
export class FollowUpStdTestComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.FollowUpStdTest;
  public showLabFinderModal = false;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the upsell card title.
   */
  public get htmlTitle(): string {
    const title =
      this.consultationStorageService.treatmentType === ConsultationTreatmentTypes.StdPrevention
        ? 'Follow-Up STI Test'
        : `${this.consultationStorageService.getTreatmentPreferenceName()} Follow-Up Urine Test`;

    return `<strong>Important:</strong> ${title}`;
  }

  /**
   * Toggle the find a lab modal.
   */
  public toggleLabFinderModal() {
    this.showLabFinderModal = !this.showLabFinderModal;
  }
}
